import * as THREE from "three";
import { webcadDefines } from "./index";

/* WarpPoint
 * ワープポイント(ウォークスルーのエントリ).
 */
export class WarpPoint {
    private _name: string;
    private _floor: number;
    private _position: THREE.Vector3;
    private _lookAt: THREE.Vector3;
    public get name(): string { return this._name; }
    public get floor(): number { return this._floor; }
    public get position(): THREE.Vector3 { return this._position; }
    public get lookAt(): THREE.Vector3 { return this._lookAt; }

    constructor(name: string, floor: number, base: number[], vector: number[]) {
        this._name = name;
        this._floor = floor;
        this._position = new THREE.Vector3(Number(base[0]), webcadDefines.WebCadCameraDefs.wlkthHeight, -Number(base[1]));
        this._lookAt = new THREE.Vector3(Number(vector[0]), webcadDefines.WebCadCameraDefs.wlkthHeight, -Number(vector[1]));
    }

    static extractWarps(userData: any, warps: WarpPoints): number {
        const warpElems = userData.warp_point;
        if ((warpElems == undefined) || (warpElems.length <= 0)) return undefined;
        warpElems.forEach((warp: any) => {
            warps.add(new WarpPoint(warp.warp_type, Number(warp.floor), warp.base_p, warp.vector));
        });
        return warps.length;
    }
}

/* WarpPoints
 * ワープポイント管理.
 */
export class WarpPoints {
    private _warps: WarpPoint[];

    constructor() {
        this.reset();
    }
    public add(warp: WarpPoint) { this._warps.push(warp); }
    public get length() { return this._warps.length; }
    public reset() { this._warps = []; }
    public getFromName(name: string) {
        for (let i = 0; i < this._warps.length; i++) {
            if (this._warps[i].name == name) return this._warps[i];
        }
    }
    public getFromIndex(index: number) {
        return this._warps[index];
    }
}
